const loadImage = (
  file: Blob | File,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = () => reject(new Error("error during the image loading"));
    img.src = URL.createObjectURL(file);
  });
};

export const validateImageDimensions = async (
  file: Blob | File,
  dimensions: [number, number],
) => {
  const image = await loadImage(file);

  if (image.width > dimensions[0] || image.height > dimensions[1]) {
    return false;
  }

  return true;
};

export const validateImageFileSize = (file: Blob | File, maxSize: number) => {
  const fileSizeKB = file.size / 1024;

  if (fileSizeKB > maxSize) {
    return false;
  }

  return true;
};

export const getMaxSizeTitle = (maxSize?: number) => {
  if (!maxSize) return undefined;

  if (maxSize < 1024) {
    return `Max Size: ${maxSize}KB`;
  }

  return `Max Size: ${maxSize / 1024}MB`;
};
